import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemeService } from '../../Services/theme.service';

@Component({
  selector: 'av-theme-toggle',
  standalone: true,
  imports: [MatIconModule, TranslatePipe],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-inline-block' },
})
export class AvThemeToggleComponent {
  private readonly _themeService = inject(ThemeService);

  readonly isDark = computed<boolean>(() => this._themeService.mode() === 'dark');

  toggle(): void {
    this._themeService.toggleMode();
  }
}
